import React, { Component } from 'react';
import LOOKUP from 'constants/lookup';
import DialogInput from 'screens/components/advanced/DialogInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import TimePickerInput from 'screens/components/basic/TimePickerInput';
import SelectInput from 'screens/components/basic/SelectInput';
import Button from 'screens/components/basic/Button';
import DialogHeader from 'screens/components/basic/DialogHeader'
import ToggleInput from 'screens/components/basic/ToggleInput';
import CheckInput from 'screens/components/basic/CheckInput';
import { TwitterPicker } from 'react-color';

const componentName = 'ScheduleAdd'

class ScheduleAddDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            color: "#893086",
        };
    }

    getColor = (color) =>{
        this.setState({...this.state, color: color.hex});
        this.props.formInput(color.hex, `${componentName}Color`);
    }

    getRecursiveRow = (dayOfWeek) => {
        return (
                <tr className="recursive_schedule_row">
                    <td style={{verticalAlign: "middle"}}>{`${dayOfWeek}`}</td>
                    <tr id="dropdown">
                        <td colSpan={2}>
                            <SelectInput
                                name={`${componentName}SelectedCustomTimeSlot${dayOfWeek}`}
                                fullWidth={true}
                                label={LOOKUP.shiftEdit.selectTimeSlot}
                                hintText={LOOKUP.shiftEdit.selectTimeSlot}
                                options={this.props.customTimeSlotsOptions}
                            />
                        </td>
                    </tr>
                    <tr id="times">
                        <td className="pr-1">
                            <TimePickerInput
                                name={`${componentName}${dayOfWeek}Start`}
                                floatingLabelText="Start Time"
                                label="Start Time"
                                hintText="Start Time"
                                fullWidth={true}
                            />
                        </td>
                        <td>
                            <TimePickerInput
                                name={`${componentName}${dayOfWeek}End`}
                                floatingLabelText="End Time"
                                label="End Time"
                                hintText="End Time"
                                fullWidth={true}
                            />
                        </td>
                    </tr>
                </tr>
        )
    }

    render(){
        const p = this.props;

        const actions = [
            <Button
                type="CancelButton"
                className="btn-space btnCleanSearch"
                label={LOOKUP.common.cancel.text}
                secondary={true}
                onTouchTap={this.props.handleDiag}
            />,
            <Button name="SaveButton"
                className="pull-right btnNewBrandPOS"
                label="Confirm"
                primary={true}
                onTouchTap={this.props.createSchedule}
            />,
            // <Button name="buttonSave"
            //     className="pull-right mr-2 btnCleanSearch"
            //     label="Cancel"
            //     onTouchTap={this.props.handleDiag}
            // />
        ]
        const colors = ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'];
        const campaignDay = LOOKUP.campaign.day;

        return(
            <DialogInput
                title={<DialogHeader text="Add new Schedule" />}
                modal={true}
                actions = {actions}
                className={this.props.recursive ? "schedule_dialog_recursive":"schedule_dialog"}
                open={p.open}
                autoScrollBodyContent={true}
            >
                <div className="col-lg-10 pt-2">
                    <ToggleInput
                        className="recursive_schedule"
                        label={"Recursive Schedule"}
                        name={`${componentName}Recursive`}
                    />
                </div>

                {
                    this.props.recursive ? (
                        <div className="row m-0">
                            <div className="col-lg-6">
                                <DatePickerInput
                                    name={`${componentName}DateStart`}
                                    floatingLabelText={"Date start"}
                                    hintText={"Date start"}
                                    fullWidth={true}
                                />
                            </div>
                            <div className="col-lg-6">
                                <DatePickerInput
                                    name={`${componentName}DateEnd`}
                                    floatingLabelText={"Date end"}
                                    hintText={"Date end"}
                                    fullWidth={true}
                                />
                            </div>
                            <div className="col-lg-12 col-xl-12">
                                {
                                    campaignDay.map((item, index) => {
                                        return (
                                            <div className="campaign_day" key={index}>
                                                <CheckInput
                                                    name={componentName + "WeekDay-" + item.text}
                                                    text={item.name}
                                                    value={item.text}
                                                />
                                            </div>
                                        );
                                    })
                                }
                            </div>
                            <div>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>Day</th>
                                            <th>Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.props.monday && (
                                                this.getRecursiveRow("Monday")
                                            )
                                        }
                                        {
                                            this.props.tuesday && (
                                                this.getRecursiveRow("Tuesday")
                                            )
                                        }
                                        {
                                            this.props.wednesday && (
                                                this.getRecursiveRow("Wednesday")
                                            )}
                                        {
                                            this.props.thursday && (
                                                this.getRecursiveRow("Thursday")
                                            )}
                                        {
                                            this.props.friday && (
                                                this.getRecursiveRow("Friday")
                                            )}
                                        {
                                            this.props.saturday && (
                                                this.getRecursiveRow("Saturday")
                                            )}
                                        {
                                            this.props.sunday && (
                                                this.getRecursiveRow("Sunday")
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-lg-12">
                                <SelectInput
                                    name={`${componentName}Employee`}
                                    floatingLabelText="Select Employee"
                                    label="Select Employee"
                                    hintText="Select Employee"
                                    options={p.employeeOptions}
                                    onChange = {this.getEmployee}
                                />
                                <div style={{borderColor: this.state.color, backgroundColor: this.state.color, border:'solid'}} width={"10%"}></div>
                                <br/>
                            </div>
                            <div className="col-lg-12">
                                <TwitterPicker width={"auto"}
                                    colors={colors}
                                    color={this.state.color}
                                    name={`${componentName}Color`}
                                    onChangeComplete= {this.getColor}
                                />
                            </div>
                        </div >
                    ) : (
                        <div className="row">
                            <div className="col-lg-12">
                                <DatePickerInput
                                    name={`${componentName}Date`}
                                    floatingLabelText={LOOKUP.shiftEdit.date.label}
                                    hintText={LOOKUP.shiftEdit.date.hintText}
                                    fullWidth={true}
                                />
                            </div>
                            <div className="col-lg-12">
                                <SelectInput
                                    name={`${componentName}SelectedCustomTimeSlot`}
                                    fullWidth={true}
                                    label={LOOKUP.shiftEdit.selectTimeSlot}
                                    hintText={LOOKUP.shiftEdit.selectTimeSlot}
                                    options={this.props.customTimeSlotsOptions}
                                />
                            </div>
                            <div className="col-lg-6">
                                <TimePickerInput
                                    name={`${componentName}Start`}
                                    floatingLabelText="Start Time"
                                    label="Start Time"
                                    hintText="Start Time"
                                    fullWidth={true}
                                />
                            </div>
                            <div className="col-lg-6">
                                <TimePickerInput
                                    name={`${componentName}End`}
                                    floatingLabelText="End Time"
                                    label="End Time"
                                    hintText="End Time"
                                    fullWidth={true}
                                />
                            </div>
                            <div className="col-lg-12">
                                <SelectInput
                                    name={`${componentName}Employee`}
                                    floatingLabelText="Select Employee"
                                    label="Select Employee"
                                    hintText="Select Employee"
                                    options={p.employeeOptions}
                                    onChange = {this.getEmployee}
                                    fullWidth={true}
                                />
                                <div style={{borderColor: this.state.color, backgroundColor: this.state.color, border:'solid'}} width={"10%"}></div>
                                <br/>
                            </div>
                            <div className="col-lg-12">
                                <TwitterPicker width={"auto"}
                                    colors={colors}
                                    color={this.state.color}
                                    name={`${componentName}Color`}
                                    onChangeComplete= {this.getColor}
                                />
                            </div>
                        </div >
                    )
                }

            </DialogInput>
        )
    }
}


export default ScheduleAddDialog;
